<template>
  <LayoutHistoryItem
    :data-qa="dataQa"
    :item="item"
    :spr="spr">
    <span slot="eventType">
      {{ customTitle }}
    </span>
    <template #parameters>
      <div/>
    </template>
  </LayoutHistoryItem>
</template>
<script>
import LayoutHistoryItem from 'components/common/blocks/history/layout/LayoutHistoryItem.vue'

import historyMixin from 'components/common/blocks/history/layout/historyMixin.js'

export default {
  name: 'HistoryItemProlongation',
  mixins: [ historyMixin ],
  computed: {
    isChangeDates() {
      return this.parametrs?.oldDateEnd  && this.parametrs?.newDateEnd
    },
    customTitle() {
      if (!this.isChangeDates) { return this.historyItemTitle }
      const oldDateEnd = `${this.$d(new Date(this.parametrs.oldDateEnd), 'shortDate')} ${this.$d(new Date(this.parametrs.oldDateEnd), 'time')}`
      const newDateEnd = `${this.$d(new Date(this.parametrs.newDateEnd), 'shortDate')} ${this.$d(new Date(this.parametrs.newDateEnd), 'time')}`
      //return `змінив дату завершення прийому пропозицій з ${oldDateEnd} на ${newDateEnd}`
      if (this.item?.newTenderStatus?.id === this.statuseKeys.AUCTION) {
        return this.$t('Tenders.HistoryBlock.prolongationDateTitleAuction', { oldDateEnd, newDateEnd })
      }
      return this.$t('Tenders.HistoryBlock.prolongationDateTitle', { oldDateEnd, newDateEnd })
    },
    customParameters() {
      const result = { ...this.parametrs }
      if (this.isChangeDates) { 
        delete result.oldDateEnd
        delete result.newDateEnd
      }
      return result
    }
  },
  components: {
    LayoutHistoryItem
  },
}
</script>
